<script setup lang="js">
import { onMounted, ref, watch } from 'vue';
import { useServiceStore } from '@/stores/service.store';
import { useProjectStore } from '@/stores/project.store';
import { useBusinessProcessStore } from '@/stores/businessProcess.store';
import { useRouteParams } from '@vueuse/router';
import { storeToRefs } from 'pinia';
import ModalTemplateSide from '@/components/modals/ModalTemplateSide.vue';
import useModal from '@/stores/modal.store';
import { useRouter } from 'vue-router';
import Multiselect from 'vue-multiselect';

const serviceStore = useServiceStore();
const projectStore = useProjectStore();
const businessProcessStore = useBusinessProcessStore();
const projectId = useRouteParams('projectId');
const serviceId = useRouteParams('serviceId');
const { project } = storeToRefs(projectStore);
const { serviceCriterions, service } = storeToRefs(serviceStore);
const { bpList } = storeToRefs(businessProcessStore);
const { closeModal } = useModal();
const businessProcess = ref('');
const router = useRouter();
const selectedCriterionValues = ref([]);
const sorteredBpList = ref([]);
const selectedCriterionValue = ref({});

watch(bpList, () => {
  sorteredBpList.value = bpList.value.filter((bp) => bp.type === service.value.type);
});

onMounted(() => {
  projectStore.getProject(projectId.value);
  serviceStore.getServiceCriterion(projectId.value, serviceId.value);
  businessProcessStore.getBPList();
});

function handleChangeCriterions(event) {
  const value = event.target.value;
  selectedCriterionValues.value.push(value);
}

function createServiceRoute() {
  let criterionValues = [];
  Object.keys(selectedCriterionValue.value).forEach((criterionKey) => {
    criterionValues.push(selectedCriterionValue.value[criterionKey].id)
  })
  serviceStore
    .createRoute(
      projectId.value,
      serviceId.value,
      criterionValues,
      businessProcess.value?.id
    )
    .then(() => {
      closeModal();
      router.push({ name: 'service-route' });
      serviceStore.getServiceRouteList(projectId.value, serviceId.value);
    });
}

function customLabel(item) {
  return item.title[project.value.default_locale];
}
</script>

<template>
  <ModalTemplateSide @submit="createServiceRoute" :disableButtons="serviceStore.createRouteRequest.isLoading">
    <template v-slot:title>Создать маршрут</template>
    <template v-slot:body>
      <div class="mt-3">
        <label class="form-label">Бизнес-процесс</label>
        <Multiselect
          v-model="businessProcess"
          :options="sorteredBpList"
          placeholder="Выбрать..."
          :multiple="false"
          label="name"
          track-by="id"
          class="multiselect-style"
        />
      </div>
      <div class="mt-3" v-for="criterion in serviceCriterions" :key="criterion.id">
        <label class="form-label">{{ criterion.title[project.default_locale] }}</label>
        <Multiselect
          v-model="selectedCriterionValue[criterion.id]"
          :options="criterion.options"
          placeholder="Выбрать..."
          :multiple="false"
          :custom-label="customLabel"
          track-by="id"
          class="multiselect-style"
        />
      </div>
    </template>
    <template v-slot:submit>Создать</template>
  </ModalTemplateSide>
</template>